import { number, option, string } from "fp-ts";
import { integerFromString } from "fp-ts-std/Number";
import { flow, pipe } from "fp-ts/lib/function";
import { Option } from "fp-ts/lib/Option";

export function getAttribute(
  attributeName: string
): (element: Element) => Option<string> {
  return function (element: Element): Option<string> {
    return pipe(element.getAttribute(attributeName), option.fromNullable);
  };
}

export function getIntAttribute(attributeName: string) {
  return flow(getAttribute(attributeName), option.flatMap(integerFromString));
}
// Hide an element
export var hide = function (elem: HTMLElement) {
  elem.classList.add("ug-hidden");
};
export var show = function (elem: HTMLElement) {
  elem.classList.remove("ug-hidden");
};
